import { render } from "./users-list.html?vue&type=template&id=2b1aa4cd&scoped=true&ts=true"
import script from "./users-list.ts?vue&type=script&lang=ts"
export * from "./users-list.ts?vue&type=script&lang=ts"

import "./users-list.scss?vue&type=style&index=0&id=2b1aa4cd&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1aa4cd"]])

export default __exports__